import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslator } from "../i18n/translator.ts";

export const ConfirmCardContactDetailsDialog = ({
  open,
  isPending,
  onClose,
  onConfirm,
}: {
  open: boolean;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const translate = useTranslator();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {translate("markContactDetailsCorrectDialogTitle")}
      </DialogTitle>
      <DialogContent>
        <Typography marginTop={0.5} sx={{ whiteSpace: "pre-line" }}>
          {translate("markContactDetailsCorrectDialogMessage")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button type="button" onClick={onClose} disabled={isPending}>
          {translate("cancel")}
        </Button>
        <Button
          type="button"
          variant="contained"
          onClick={onConfirm}
          disabled={isPending}
        >
          {translate("markContactDetailsCorrect")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
